<fr-isc-form Id="delete-tenant" [FDN]="FDN" [formModel]="data" [mode]="'edit'" [buttons]="buttons">
</fr-isc-form>
